import { acquisitionErrorContext } from "@litres/errors";

export const requestRequiresCaptchaError = acquisitionErrorContext.feature(
  "RequestRequiresCaptcha"
);
